import * as React from 'react';
import { default as RenderToggle } from 'material-ui/Toggle';

import * as T from '@components/form/Tree/_treeTypes';
import Add from 'material-ui/svg-icons/content/add';
import Remove from 'material-ui/svg-icons/content/remove';

const childrenStyle: React.CSSProperties = { marginLeft: 40, marginBottom: '10px' };
const headStyle = (hasChildren): React.CSSProperties => ({
  cursor: hasChildren ? 'pointer' : 'auto',
  display: 'flex',
  alignItems: 'center',
  margin: '5px 0'
});
const nameStyle = (hasChildren: boolean): React.CSSProperties => ({
  fontWeight: hasChildren ? 'bold' : 'normal'
});
const unpackStyle = (hasChildren: boolean): React.CSSProperties => ({
  visibility: hasChildren ? 'visible' : 'hidden'
});

const TreeNode: React.SFC<any & { node: T.Node }> = ({ node, ...rest }) => {
  const { id, name, children } = node;
  const { selectedValue, unpackedItems, handleValue, handleUnpackedItems } = rest;

  const toggled = selectedValue === id;
  const hasChildren = !!children.length;
  const unpacked = unpackedItems.find(i => i === id);

  return (
    <div className="tree-node">
      <div
        className="head"
        style={headStyle(hasChildren)}
        onClick={evt => {
          evt.stopPropagation();
          if (hasChildren) {
            handleUnpackedItems(id);
          }
        }}
      >
        <div className="check" onClick={evt => evt.stopPropagation()}>
          <RenderToggle toggled={toggled} onToggle={() => handleValue(toggled ? null : id)} />
        </div>
        <div className="unpack" style={unpackStyle(hasChildren)}>
          {unpacked ? <Remove /> : <Add />}
        </div>
        <div className="label" style={nameStyle(hasChildren)}>
          {name}
        </div>
      </div>
      {unpacked && (
        <div className="children" style={childrenStyle}>
          {children.map(o => (
            <TreeNode key={o.id} node={o} {...rest} />
          ))}
        </div>
      )}
    </div>
  );
};

export const Tree: React.SFC<T.OutterProps> = ({ treeData, ...rest }) => {
  return (
    <div className="tree-root">
      <div className="nodes">
        {treeData.map(o => (
          <TreeNode key={o.id} node={o} {...rest} />
        ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form/Tree/Tree.tsx